import { useState, useEffect } from "react";
import { useUserLectures } from "../../userProfile/userLectures/hooks/useUserLectures";
import { useSearchParams } from "react-router-dom";

const useIsOfferOwned = (offer) => {
    const [isOwned, setIsOwned] = useState(false);
    const [searchParams] = useSearchParams();

    const perPage = 5;

    const page = searchParams.get("page")
        ? parseInt(searchParams.get("page"), 10) < 1
            ? 1
            : parseInt(searchParams.get("page"), 10)
        : 1;
    const { userLectures, isPending } = useUserLectures({
        perPage,
        page,
    });
    useEffect(() => {
        if (isPending) return;
        // If userLectures or offers are not available, do nothing
        if (!userLectures || !offer) {
            return;
        }

        // Extract the lecture IDs from userLectures and offer
        const userLectureIds = userLectures?.data?.map((lecture) => lecture.id);
        const offerLectureIds = offer?.relationships?.lectures.map(
            (lecture) => lecture.id
        );

        // Check if all offer lectures are in user lectures
        const areAllOfferLecturesInUserLectures = offerLectureIds?.every((id) =>
            userLectureIds?.includes(id)
        );

        // Update the isOwned state
        setIsOwned((prev) => {
            if (prev !== areAllOfferLecturesInUserLectures) {
                return areAllOfferLecturesInUserLectures;
            }
            return prev;
        });
    }, [userLectures, offer, setIsOwned, isPending]);

    return { isOwned, isPending };
};
export default useIsOfferOwned;
